var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-view" },
    [
      _vm._l(_vm.content, function(item) {
        return _c(
          "a",
          {
            key: item.id,
            staticClass: "item row",
            attrs: { href: _vm.$router.options.base + "propiedades/" + item.id }
          },
          [
            _c("div", { staticClass: "col-4 pr-1" }, [
              _c("div", { staticClass: "overflow-hidden position-relative" }, [
                (item.status || item.reappraised) && item.status == "available"
                  ? _c("span", { staticClass: "item-featured" }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            !item.highlight && item.reappraised
                              ? "RETASADO"
                              : "DESTACADA"
                          ) +
                          "\n\t\t\t\t"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                item.status_str
                  ? _c("span", { staticClass: "item-status" }, [
                      _vm._v(_vm._s(item.status_str))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "item-figure embed-responsive embed-responsive-4by3",
                  style: "background-image: url(" + item.img + ")"
                }),
                _vm._v(" "),
                _c("div", { staticClass: "item-pricing" }, [
                  _c("span", { staticClass: "item-price" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(item.currency.name) +
                        " " +
                        _vm._s(item.price) +
                        "\n\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "item-type" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(
                          item.property_type.name +
                            " en " +
                            item.transaction_type.name
                        ) +
                        "\n\t\t\t\t\t"
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-8 d-flex flex-column" }, [
              _c("h4", { staticClass: "item-title" }, [
                _vm._v(_vm._s(item.title))
              ]),
              _vm._v(" "),
              _c("address", { staticClass: "item-address" }, [
                _c("i", { staticClass: "icon-location" }),
                _vm._v(
                  " " +
                    _vm._s(item.address) +
                    "\n\t\t\t\t" +
                    _vm._s(item.address_number) +
                    ", " +
                    _vm._s(item.city.name) +
                    "\n\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "item-desc" }, [
                _vm._v(_vm._s(item.short_description))
              ]),
              _vm._v(" "),
              item.rooms ||
              item.bedrooms ||
              item.bathrooms ||
              item.m2_covered ||
              item.m2
                ? _c("ul", { staticClass: "item-details" }, [
                    item.rooms
                      ? _c("li", { staticClass: "item-detail" }, [
                          _c("i", { staticClass: "icon-home" }),
                          _vm._v(
                            " " + _vm._s(item.rooms) + " Ambientes\n\t\t\t\t"
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.bedrooms
                      ? _c("li", { staticClass: "item-detail" }, [
                          _c("i", { staticClass: "icon-bed" }),
                          _vm._v(
                            " " + _vm._s(item.bedrooms) + " Dorm\n\t\t\t\t"
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.bathrooms
                      ? _c("li", { staticClass: "item-detail" }, [
                          _c("i", { staticClass: "icon-droplet" }),
                          _vm._v(
                            " " + _vm._s(item.bathrooms) + " Baños\n\t\t\t\t"
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.m2_covered || item.m2
                      ? _c("li", { staticClass: "item-detail" }, [
                          _c("i", { staticClass: "icon-codeopen" }),
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                item.m2_covered
                                  ? item.m2_covered + " m² Cub"
                                  : "Sup. " + item.m2 + "m²"
                              ) +
                              "\n\t\t\t\t"
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          ]
        )
      }),
      _vm._v(" "),
      _vm.total > _vm.pageSize
        ? _c("div", { staticClass: "col-12 pagination mt-3" }, [
            _c("p", { staticClass: "pagination-summary" }, [
              _vm._v(
                "\n\t\t\tTotal de Inmuebles: " +
                  _vm._s(_vm.total) +
                  ", mostrando del\n\t\t\t" +
                  _vm._s((_vm.pageNumber - 1) * _vm.pageSize + 1) +
                  " al\n\t\t\t" +
                  _vm._s((_vm.pageNumber - 1) * _vm.pageSize + _vm.pageSize) +
                  "\n\t\t"
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pagination-list" },
              [
                _vm.pageNumber > 1
                  ? _c(
                      "router-link",
                      {
                        staticClass: "pagination-item pagination-item_prev",
                        attrs: {
                          to: {
                            query: {
                              list: null,
                              pageNumber: _vm.pageNumber - 1
                            }
                          }
                        }
                      },
                      [_vm._v("\n\t\t\t\tAnterior\n\t\t\t")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.pagination, function(p, n) {
                  return [
                    p
                      ? _c(
                          "router-link",
                          {
                            key: "p_" + n,
                            staticClass: "pagination-item",
                            class: {
                              "pagination-item_active": p == _vm.pageNumber
                            },
                            attrs: {
                              to: {
                                query: Object.assign({}, _vm.$route.query, {
                                  list: null,
                                  pageNumber: p
                                })
                              }
                            }
                          },
                          [_vm._v("\n\t\t\t\t\t" + _vm._s(p) + "\n\t\t\t\t")]
                        )
                      : _c(
                          "span",
                          {
                            key: "p_" + n,
                            staticClass: "pagination-item pagination-item_dots"
                          },
                          [_vm._v("\n\t\t\t\t\t...\n\t\t\t\t")]
                        )
                  ]
                }),
                _vm._v(" "),
                _vm.pageNumber < _vm.total
                  ? _c(
                      "router-link",
                      {
                        staticClass: "pagination-item pagination-item_next",
                        attrs: {
                          to: {
                            query: {
                              list: null,
                              pageNumber: _vm.pageNumber + 1
                            }
                          }
                        }
                      },
                      [_vm._v("\n\t\t\t\tSiguiente\n\t\t\t")]
                    )
                  : _vm._e()
              ],
              2
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }